import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { myContext } from '../App';
import { Helmet } from 'react-helmet-async';
import ContactPopup from './contactPopup';
import ThankYouPopup from './thankyouPopUp';


export function Integrations() {

  // use useNavigate hook to redirect the user to any other page
  const navigate = useNavigate();
  // Import and use the useContext hook to access the data from app.jsx
  const footerContext = useContext(myContext);
  const [popup, setpopup] = useState(false)
  const [modalState, setModalState] = useState(null); // 'contact | thanks | null'

  const navigateTo = (path) => {
    footerContext.setRender(!footerContext.render);
    navigate(path)
  }

  useEffect(() => {}, [modalState]);

  // const eciRef = useRef(null);
  // const salesRef = useRef(null)

  // useEffect(() => {

  //   if (window.location.href.includes('eci-integration-section')) eciRef.current.scrollIntoView({ behavior: 'smooth' });

  //   else if(window.location.href.includes('salesChain-integration-section')) salesRef.current.scrollIntoView({ behavior: 'smooth' });

  // }, [])

  const eciRef = useRef(null);
  const salesRef = useRef(null);
  const location = useLocation();

  useLayoutEffect(() => {
    // Scroll to the top of the page initially
    window.scrollTo(0, 0);

    const scrollToSection = () => {
      if (window.location.hash) {
        const hash = window.location.hash.substring(1); // Remove the '#'
        if (hash === 'eci-integration-section' && eciRef.current) {
          eciRef.current.scrollIntoView({ behavior: 'smooth' });
        } else if (hash === 'salesChain-integration-section' && salesRef.current) {
          salesRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    // Use a timeout to allow the DOM to be fully ready before trying to scroll
    const timeout = setTimeout(scrollToSection, 0);

    window.addEventListener('hashchange', scrollToSection);

    // Cleanup event listener on unmount
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('hashchange', scrollToSection);
    };
  }, [location]);

  const onContactUsClick = async () => {
    footerContext.setIsThankMessage(true);
    // setpopup(true);
    setModalState("contact");
}

  return <>
    <>
      <Helmet>

        <title>Integrations | Canon Financial Services</title>

        <meta name="description" content="Learn more about our integrations across the CFS network. We partner with organizations like e-automate, SalesChain, and more to make data transfer and accuracy easy." />

        <link rel="canonical" href="https://www.cfs.canon.com/Integrations" />

      </Helmet>

      <div className="container-fluid position-relative px-0 industry-banner">
        <div className="">
          <img
            src="images/Integration banner image.jpg"
            className="img-fluid w-100 object-fit-cover"
            alt="..."
          />
        </div>
        <div className="container text-center banner-content-overlap position-absolute top-50 start-50 translate-middle">
          <h1>Integrations For You</h1>
          <span className="d-inline-block mb-4 banner-description mt-4 w-75">
            We have partnered with the systems you love for integrations that save
            you time and resources.
          </span>
        </div>
      </div>
      {/* Banner Section Ends here */}
      {/* CTA Section Starts here */}
      <div className="primary-gradient-bg text-center">
        <div className="cta-custom-width pb-4">
          <p className="font-34 secondary-color font-bold pt-3 mb-0 text-uppercase">
            DON’T SEE AN INTEGRATION YOU NEED?
          </p>
          <span className="d-block mb-2 banner-description">
            We are integration ready! If you don’t see the integration you are
            looking for, please reach out to our team.
          </span>
          <button onClick={() => { onContactUsClick() }} className="text-uppercase">
            CONTACT US
          </button>
        </div>
      </div>
      {/* CTA Section Ends here */}
      {/* Left and right Section Starts here */}
      <div className="container-fluid">
        <div className="py-2 my-4 mx-3 mx-lg-0 text-center d-flex justify-content-center flex-wrap">
          <h2 className="grey-color-v1 w-100">AVAILABLE INTEGRATIONS</h2>
          <p className="font-20 font-regular line-height-26 mb-2 text-start w-75 w-sm-100 text-mob-center">
            Integrations make your life simpler. Thats why we work hard to offer
            integrations with leading services. Here are a few of the integrations
            that we offer to our financial partners.
          </p>
        </div>
        <div className="row pt-4 align-items-center" id="eci-integration-section" ref={eciRef}>
          <div className="col-md-6 px-0 order-1 order-md-1 left-right-sec-img">
            <img
              src="images/ECI - Integrations Page.jpg"
              className="section-img w-100 object-position-center"
              alt="section-img"
            />
          </div>
          <div className="col-md-6 order-2 order-md-1">
            <div className="left-i-and-right-c-sec-spacing">
              <div className="container">
                <h2 className="mb-3 grey-color-v1">ECI Integration</h2>
                <p className="font-20 font-regular line-height-26 mb-2">
                  Automatically import your meter reads, via e-automate® by ECI, for
                  an increase in the overall efficiency of your service operations.
                  In addition to importing all meter reads, CFS can also cash-post
                  funds received from your remittance to close your open invoices.
                </p>
                <ul className="success-list">
                  <li className="font-20 font-regular">
                    Increase information accuracy
                  </li>
                  <li className="font-20 font-regular">
                    Streamline workflows and processes
                  </li>
                  <li className="font-20 font-regular">Reduce manual work</li>
                  <li className="font-20 font-regular">
                    Greater efficiency, productivity, and reliability
                  </li>
                  <li className="font-20 font-regular">And more!</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-4 align-items-center" id="salesChain-integration-section" ref={salesRef}>
          <div className="col-md-6 order-2 order-md-1">
            <div className="left-i-and-right-c-sec-spacing">
              <div className="container">
                <h2 className="mb-3 grey-color-v1">SalesChain Integration</h2>
                <p className="font-20 font-regular line-height-26 mb-2">
                  Get all the information you need to service your accounts in an
                  organized and timely manner. Submit credit applications, create
                  workflows, and pull leases from CFS and automatically import them
                  into the SalesChain database for a full view of your customer.
                </p>
                <ul className="success-list">
                  <li className="font-20 font-regular">
                    Easily submit and view credit apps
                  </li>
                  <li className="font-20 font-regular">View customer invoices</li>
                  <li className="font-20 font-regular">Streamline data transfer</li>
                  <li className="font-20 font-regular">
                    View lease portfolio at any time
                  </li>
                  <li className="font-20 font-regular">And more!</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 px-0 order-1 order-md-1 left-right-sec-img">
            <img
              src="images/SalesChain  Integrations-banner.jpg"
              className="section-img w-100 object-position-center"
              alt="section-img"
            />
          </div>
        </div>
      </div>
    </>
    {modalState === "contact" && <ContactPopup closeContactPopup={() => setModalState(null)} onSuccess={() => 
            {
                setModalState("thanks");
                console.log('Modal state after success: ', modalState);

            }} />} 
        {modalState === "thanks" && 
        <>
        ({console.log('rednering thank you pop up')})
        <ThankYouPopup closeThankYou={() => setModalState(null)} />
        </>}
  </>

}